import { useTranslation } from 'react-i18next';

export default function Advantages() {
  const { t } = useTranslation();

  const advantages = [
    {
      icon: 'ri-timer-flash-line',
      title: t('about_features_feature1_title'),
      desc: t('about_features_feature1_desc'),
      image: 'https://readdy.ai/api/search-image?query=Multiple%20monitors%20showing%20live%20social%20media%20feeds%20with%20news%20alerts%2C%20modern%20tech%20command%20center%2C%20warm%20dark%20room%20with%20screen%20glow%2C%20real-time%20monitoring%20setup%2C%20professional%20surveillance%20room%2C%20dramatic%20lighting&width=800&height=600&seq=about-advantage-01&orientation=landscape',
    },
    {
      icon: 'ri-global-line',
      title: t('about_features_feature2_title'),
      desc: t('about_features_feature2_desc'),
      image: 'https://readdy.ai/api/search-image?query=Digital%20network%20visualization%20with%20interconnected%20social%20platforms%2C%20abstract%20data%20flow%2C%20modern%20tech%20background%2C%20warm%20orange%20and%20cream%20gradient%2C%20clean%20minimal%20design%2C%20information%20aggregation%20concept&width=800&height=600&seq=about-advantage-02&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: t('about_features_feature3_title'),
      desc: t('about_features_feature3_desc'),
      image: 'https://readdy.ai/api/search-image?query=Open%20book%20with%20glowing%20pages%20on%20minimalist%20desk%2C%20symbolic%20free%20knowledge%2C%20warm%20lighting%2C%20clean%20modern%20interior%2C%20elegant%20simplicity%2C%20concept%20of%20open%20access%2C%20soft%20natural%20light&width=800&height=600&seq=about-advantage-03&orientation=landscape',
    },
  ];

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              {t('about_features_title1')}
              <br />
              {t('about_features_title2')}
            </h2>
          </div>
          <p className="text-sm text-foreground-600">{t('about_features_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {advantages.map((item, idx) => (
            <div
              key={idx}
              className={`group block rounded-2xl bg-background-100 overflow-hidden transition-all duration-300 hover:scale-[1.02] ${
                idx === 0 ? 'md:col-span-1' : ''
              }`}
            >
              {idx === 0 ? (
                <>
                  <div className="relative w-full aspect-[16/10] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <i className={`${item.icon} text-primary-600 text-base`}></i>
                      </span>
                      <h3 className="text-base md:text-lg font-semibold text-foreground-950 whitespace-nowrap">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-sm text-foreground-600">{item.desc}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="p-5">
                    <div className="flex items-center justify-center gap-2 mb-3">
                      <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <i className={`${item.icon} text-primary-600 text-base`}></i>
                      </span>
                      <h3 className="text-base font-semibold text-foreground-950 whitespace-nowrap">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                  <div className="relative w-full aspect-[16/9] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <p className="text-sm text-foreground-600 text-center">{item.desc}</p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}